export const AddContactLabel = "Add Contact";
export const CompanyLabel = "Company Name";
export const id = "id";
export const Contact_Name = "contact_name";
export const ContactHeader = "Contact";
export const email = "email";
export const Email = "Email";
export const Contact_No = "contact_no";
export const ContactNo = "Contact No";
export const Contact_Location = "contact_location";
export const Address = "Address";
export const Position_id = "position_id";
export const Position = "Position";
export const Company_Name = "company_name";
export const Company = "Company";
export const Actions = "Actions";
export const Contacts = "Contacts";
export const AddContact = "Add Contact";
export const UpdateContact = "Update Contact";
export const Update = "Update";
export const Submit = "Submit";
export const Company_Id = "company_id";
export const Name = "Contact Name";
export const ContactPlaceholder = "contact name";
export const EmailPlaceholder = "email address";
export const ContactNumPlaceholder = "contact number";
export const DeleteConfirmation =
  "Are you sure you want to delete this contact?";
export const CompanyKey = "company.company_name";
export const Contact_Remarks = "remarks";
export const SearchContact = "Search Contact";
